import { PaStatus } from "../../../../enums/paStatus";
import { RouteVia } from "../../../../enums/routeVia";
import { findPaStatusBucket } from "../../../../pages/pharmaOncologySubmission/table/utils/getPaStatusBucketBadgeStyles";
import { AsteraSubmissionInitialData } from "../hooks/useAsteraSubmissionData";
import { getAsteraSubmissionDisplayComment } from "./getAsteraSubmissionDisplayComment";
import { resolvePaOutcomeClassificationForSave } from "./getNestedOptions";

/**
 * Resolves the PA Status Reason dropdown value from API classification text.
 *
 * @input classification - Raw `pa_outcome_classification` from the API
 * @return Bucket option id when recognized, otherwise the original string
 */
const resolvePaStatusReasonFromClassification = (
  classification: string,
): string => {
  const bucket = findPaStatusBucket(classification);
  return bucket ?? classification;
};

/**
 * Builds initial Astera submission form values from row data, including
 * PA-outcome-driven defaults for the PA Status Reason field.
 *
 * @input data - Table row or order record (camelCase or snake_case fields)
 * @return AsteraSubmissionInitialData: Prefilled form values for the modal
 */
export const buildAsteraSubmissionInitialData = (
  data: Record<string, unknown>,
): AsteraSubmissionInitialData => {
  const responseStatus = String(
    data.responseStatusValue ?? data.response_status ?? PaStatus.PENDING,
  );

  const comment = getAsteraSubmissionDisplayComment(data);

  const classificationRaw =
    data.pa_outcome_classification ?? data.paOutcomeClassification ?? null;

  let paStatusReason = "";
  if (classificationRaw && String(classificationRaw) !== "--") {
    paStatusReason = resolvePaStatusReasonFromClassification(
      String(classificationRaw),
    );
  } else {
    paStatusReason = String(data.paStatusReason ?? data.pa_status_reason ?? "");
    if (paStatusReason === "--") {
      paStatusReason = "";
    }
  }

  return {
    cmmId: String(
      data.cmmId ?? data.cmm_result_key ?? data.covermymed_id ?? "",
    ),
    routeViaValue: String(data.routeViaValue || data.route_via || RouteVia.CMM),
    responseStatusValue: responseStatus,
    paStatusReason: resolvePaOutcomeClassificationForSave(
      responseStatus,
      paStatusReason,
    ),
    comment,
  };
};
